"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemContentWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
exports.DashboardItemContentWrapper = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_measure_1.default, { client: true }, function (_a) {
        var _b, _c;
        var measureRef = _a.measureRef, contentRect = _a.contentRect;
        return (react_1.default.createElement("div", { className: "dash-item-content-wrapper", ref: measureRef }, children({
            clientWidth: (_b = contentRect.client) === null || _b === void 0 ? void 0 : _b.width,
            clientHeight: (_c = contentRect.client) === null || _c === void 0 ? void 0 : _c.height,
        })));
    }));
};
//# sourceMappingURL=DashboardItemContentWrapper.js.map